<template>
  <facture-client
    v-if="factureClientHupmediaActive"
    :tiersInformation="tiersInformation"/>
  <c-ventes-facture
    v-else
    :tiersInformation="tiersInformation"/>
</template>

<script>
import CVentesFacture from '@/components/clients/clients/c_ventesFacture';
import FactureClient from '@/components/clients/clients/factureClient';

export default {
  name: 'OngletFactureClient',
  components: {
    FactureClient,
    CVentesFacture,
  },
  props: {
    tiersInformation: {
      type: Object,
      required: true,
    },
    factureClientHupmediaActive: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation.nomCommercial }));
  },
};
</script>
